import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Gateway.module.scss';

export const GatewayMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>The</div>
        <div className={styles.mainSection_2}>to the Future</div>
        <div className={styles.mainSection_3}>Gateway</div>
        <div className={styles.respMainSection_1}>The Gateway</div>
        <div className={styles.respMainSection_2}>to the Future</div>
      </div>
    }
    rightContent={null}
  />
);
